import { Form, message, Select } from "antd";
import { useEffect, useState } from "react";
import _NewapplicationService from "../../modules/NewapplicationService";
import { COMMON_ERROR_MSG } from "../../constants/constants";
const { Option } = Select;
const SelectBankDDL = () => {
    const [bankNames, setBankNames] = useState([]);
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    const [email] = useState(localStorage.getItem("ApplicationEmailId") ?? localStorage.getItem("loginEmail"));
    const bankadminIdRaw = localStorage.getItem("BankAdminId");
    const BankAdminID = bankadminIdRaw ? parseInt(bankadminIdRaw) : null;
    const [BankAdminId, setBankAdminID] = useState(BankAdminID);
    const IsFirmAdmin = JSON.parse(localStorage.getItem("IsSwitchFirmAdmin"));
    useEffect(() => {
        getBankAdminListByEmail(email)
    }, []);
    useEffect(() => {
        if (BankAdminId) {
            form.setFieldsValue({ role: BankAdminId });
        }

    }, [BankAdminId, form]);
    const handleChange = (value) => {
        localStorage.setItem("BankAdminId", value);
        form.setFieldsValue({ role: value });
        window.dispatchEvent(new CustomEvent("BankAdminIdChanged", {
            detail: { newId: value }
        }));
    }
    const getBankAdminListByEmail = async (email) => {
        setLoading(true);
        try {
            const res = await _NewapplicationService.getBankAdminListByEmail(email, IsFirmAdmin);
            if (res.data.IsSuccess) {
                setLoading(false);
                // getApplicationsByEmailId(email, BankAdminId ?? res.data.Obj[0].Id);
                setBankNames(res.data.Obj);
            } else {
                setLoading(false);
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
    }
    return (
        <>
            <Form form={form} layout="horizontal">

                <Form.Item
                    name="role"
                    label="Select Bank"
                    className="selectBankLabel"
                    style={{ marginBottom: 0 }}
                >

                    <Select
                        placeholder="Select Bank"
                        onChange={handleChange}
                        style={{ minWidth: 250 }}
                    >
                        {bankNames.map((obj) => (
                            <Option key={obj.Id} value={obj.Id}>
                                {obj.BankName}
                            </Option>
                        ))}
                    </Select>

                </Form.Item>

            </Form>

        </>
    )
}
export default SelectBankDDL;